import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { apiRoutes } from "../../../../routes/api/apiRoutes";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";
const ProgramAdd = () => {
  const [formData, setFormData] = useState({
    name: "",
    image: null,
    duration: "",
    type: "",
    description: "",
    learning_points: "",
    age: "",
    activities: "",
    rating: "",
    tag: "DEV",
    curriculum: null,
    price: "",
  });
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
  useEffect(() => {
    if (response?.data && statusCode === 201) {
      toast.success("Program added successfully!");
      setTimeout(() => {
        navigate(uiRoutes.admin.program.list); // Adjust route accordingly
      }, 1000);
    }
  }, [response, statusCode, navigate]);
  const handleSubmit = (e) => {
    e.preventDefault();
    const submitData = new FormData();
    Object.keys(formData).forEach((key) => {
      submitData.append(key, formData[key]);
    });
    callAPI("post", "admin/programs", submitData);
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, image: file });
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImagePreview(null);
    }
  };
  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container mt-5">
          <PageHeading
            title="Add Program"
            subTitle="Fill out the details of programs"
          />
          <div className="container card p-4 shadow-sm mt-3">
            <form
              onSubmit={handleSubmit}
              className="row g-3"
              encType="multipart/form-data"
            >
              <h6 className="">Add Program Form</h6>
              <div className="col-md-4">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.name}
                </span>
              </div>
              <div className="col-md-4">
                <label className="form-label">Image Upload</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={handleImageChange}
                />
                {imagePreview && (
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="mt-2"
                    style={{
                      width: "100%",
                      maxHeight: "200px",
                      objectFit: "contain",
                    }}
                  />
                )}
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.image}
                </span>
              </div>
              <div className="col-md-4">
                <label className="form-label">Duration</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.duration}
                  onChange={(e) =>
                    setFormData({ ...formData, duration: e.target.value })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" &&
                    error?.data?.duration}
                </span>
              </div>
              <div className="col-md-4">
                <label className="form-label">Type</label>
                <select
                  className="form-select"
                  value={formData.type}
                  onChange={(e) =>
                    setFormData({ ...formData, type: e.target.value })
                  }
                >
                  <option value="">Select Type</option>
                  <option value="student">Student</option>
                  <option value="kids">Kids</option>
                </select>
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.type}
                </span>
              </div>
              <div className="col-md-4">
                <label className="form-label">Age Group</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.age}
                  onChange={(e) =>
                    setFormData({ ...formData, age: e.target.value })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.age}
                </span>
              </div>
              <div className="col-md-4">
                <label className="form-label">Activities</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.activities}
                  onChange={(e) =>
                    setFormData({ ...formData, activities: e.target.value })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" &&
                    error?.data?.activities}
                </span>
              </div>
              <div className="col-md-3">
                <label className="form-label">Rating</label>
                <input
                  type="number"
                  className="form-control"
                  min="0"
                  max="5"
                  step="0.1"
                  value={formData.rating}
                  onChange={(e) =>
                    setFormData({ ...formData, rating: e.target.value })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.rating}
                </span>
              </div>
              <div className="col-md-3">
                <label className="form-label">Tag</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.tag}
                  onChange={(e) =>
                    setFormData({ ...formData, tag: e.target.value })
                  }
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Price</label>
                <input
                  type="number"
                  className="form-control"
                  value={formData.price}
                  onChange={(e) =>
                    setFormData({ ...formData, price: e.target.value })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.price}
                </span>
              </div>
              <div className="col-md-3">
                <label className="form-label">Curriculum (PDF)</label>
                <input
                  type="file"
                  accept="application/pdf"
                  className="form-control"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      curriculum: e.target.files[0],
                    })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" &&
                    error?.data?.curriculum}
                </span>
              </div>
              <div className="col-md-6">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  rows="2"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" &&
                    error?.data?.description}
                </span>
              </div>
              <div className="col-md-6">
                <label className="form-label">Learning Points</label>
                <textarea
                  className="form-control"
                  rows="2"
                  value={formData.learning_points}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      learning_points: e.target.value,
                    })
                  }
                />
                <span className="val-message text-danger">
                  {error?.message === "ValidationError" &&
                    error?.data?.learning_points}
                </span>
              </div>
              <div className="col-4 mt-5 mb-5">
                <button type="submit" className="btn btn-primary w-100">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      }
    />
  );
};
export default ProgramAdd;